import { GET_DISBURSEMENT_FORM_LIST } from "../../../Types";

const DisbursementFormListReducer = (state = [], action) => {
  switch (action.type) {
    case GET_DISBURSEMENT_FORM_LIST:
      return action.payload;
    default:
      return state;
  }
};
export default DisbursementFormListReducer;
